module.exports = __webpack_public_path__ + "static/media/ic_首页.1f22de70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_首页.svg
// module id = 189
// module chunks = 0